<template>
  <div class="invite-page">
    <div class="invite-card" v-loading="loading">
      <template v-if="error">
        <i class="el-icon-warning-outline invite-icon invite-icon--error"></i>
        <h3 class="invite-title">Invitación no disponible</h3>
        <p class="invite-text">{{ error }}</p>
        <el-button type="primary" @click="$router.push('/login')">
          Ir al inicio de sesión
        </el-button>
      </template>

      <template v-else-if="invitation">
        <i class="el-icon-user invite-icon"></i>
        <h3 class="invite-title">
          Te invitaron a unirte a
          <strong>{{ invitation.business_name || "un negocio" }}</strong>
        </h3>
        <p class="invite-text">
          Rol asignado:
          <el-tag size="small" type="primary">{{ roleLabel }}</el-tag>
        </p>
        <p class="invite-text text-muted">
          Invitación enviada a <strong>{{ invitation.email }}</strong>
        </p>

        <template v-if="isLogged">
          <el-button
            type="primary"
            :loading="accepting"
            @click="acceptNow"
            class="invite-btn"
          >
            Aceptar invitación
          </el-button>
        </template>
        <template v-else>
          <p class="invite-text">
            Para aceptar, inicia sesión o crea una cuenta con el correo
            invitado.
          </p>
          <el-button type="primary" class="invite-btn" @click="goLogin">
            Ya tengo cuenta — Iniciar sesión
          </el-button>
          <el-button class="invite-btn" @click="goRegister">
            Crear cuenta nueva
          </el-button>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import teamService from "../services/index";

export default {
  name: "AcceptInvitation",
  data() {
    return {
      loading: true,
      accepting: false,
      invitation: null,
      error: null
    };
  },
  computed: {
    token() {
      return this.$route.query.token || "";
    },
    isLogged() {
      return this.$store.getters.isLogged;
    },
    roleLabel() {
      return this.invitation && this.invitation.role === "admin"
        ? "Administrador"
        : "Miembro";
    }
  },
  async created() {
    if (!this.token) {
      this.error = "El enlace de invitación no es válido.";
      this.loading = false;
      return;
    }
    try {
      const { data } = await teamService.getInvitationPreview(this.token);
      if (data.success) this.invitation = data.data;
      else this.error = data.message || "La invitación no está disponible.";
    } catch (e) {
      this.error =
        (e && e.response && e.response.data && e.response.data.message) ||
        "La invitación no existe, expiró o ya fue usada.";
    }
    this.loading = false;
  },
  methods: {
    async acceptNow() {
      this.accepting = true;
      try {
        const { data } = await teamService.acceptInvitation({
          token: this.token
        });
        if (data.success) {
          this.$notifications.success({
            message: data.message || "Te uniste al equipo."
          });
          this.$router.push({ name: "dashboard" });
        }
      } catch (e) {
        const msg =
          (e && e.response && e.response.data && e.response.data.message) ||
          "No se pudo aceptar la invitación.";
        this.$notifications.error({ message: msg });
      }
      this.accepting = false;
    },
    saveTokenForLater() {
      localStorage.setItem("pending_team_invite", this.token);
    },
    goLogin() {
      this.saveTokenForLater();
      this.$router.push("/login");
    },
    goRegister() {
      this.saveTokenForLater();
      this.$router.push("/register");
    }
  }
};
</script>

<style lang="scss" scoped>
.invite-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f6f8fb;
  padding: 24px;
}
.invite-card {
  background: #fff;
  border: 1px solid #e4eaf6;
  border-radius: 14px;
  box-shadow: 0 8px 24px rgba(45, 43, 85, 0.08);
  max-width: 440px;
  width: 100%;
  padding: 40px 32px;
  text-align: center;
}
.invite-icon {
  font-size: 42px;
  color: #3ecfb4;
  margin-bottom: 12px;
  display: inline-block;
  &--error {
    color: #e6a23c;
  }
}
.invite-title {
  color: #2d2b55;
  font-weight: 600;
  margin-bottom: 12px;
}
.invite-text {
  color: #606266;
  margin-bottom: 12px;
}
.invite-btn {
  display: block;
  width: 100%;
  margin: 0 0 10px 0 !important;
}
</style>
